import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from '../../../shared/services/api.service';
import { AuthService } from '../../../shared/services/auth.service';

@Component({
  standalone: false,
  selector: 'app-mfa-prompt',
  templateUrl: './mfa-prompt.component.html',
  styleUrls: ['./mfa-prompt.component.scss']
})
export class MfaPromptComponent implements OnInit {
  isMfaEnabled: boolean = false;
  isLoading: boolean = true;
  showPrompt: boolean = false;

  constructor(
    private apiService: ApiService,
    private authService: AuthService,
    private router: Router
  ) { }

  checkMfaStatus(): void {
    const user = this.authService.getUser();
    if (user && user.email) {
      this.apiService.postData('/users/totp-mfa/status', { email: user.email }).subscribe({
        next: (res: any) => {
          this.isLoading = false;
          if (res && !res.error) {
            this.isMfaEnabled = res.data.isMfaEnabled;
            // Show prompt if MFA is not enabled
            this.showPrompt = !this.isMfaEnabled;
          }
        },
        error: (error) => {
          this.isLoading = false;
          console.error('Error checking MFA status:', error);
        }
      });
    }
  }

  setupMfa(): void {
    this.router.navigate(['/app/mfa']);
  }

  dismissPrompt(): void {
    this.showPrompt = false;
    try {
      sessionStorage.setItem('mfaBannerDismissed', 'true');
    } catch (e) {
      // sessionStorage may not be available
    }
  }

  ngOnInit(): void {
    try {
      const dismissed = sessionStorage.getItem('mfaBannerDismissed');
      if (dismissed === 'true') {
        this.showPrompt = false;
        this.isLoading = false;
        return;
      }
    } catch (e) {
      // sessionStorage may not be available
    }
    this.checkMfaStatus();
  }
}